import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import attendance from "../../../Assets/Projects/mobile/Absen.png";

function SmartAttendance() {
  return (
    <ProjectDetailCard
      title="Smart Attendance System"
      image={attendance}
      screenshots={[attendance, attendance, attendance]}
      description="
      Smart Attendance System is a mobile application developed to digitalize the student attendance process through an efficient and user-friendly platform. The application enables students to submit attendance online, while teachers can monitor, validate, and manage attendance records in real time. It also provides attendance history, reporting features, and centralized data management, reducing manual paperwork and improving the accuracy and efficiency of classroom attendance administration.
      "
      technologies={[
        "Flutter",
        "Dart",
        "Firebase",
        "Android Studio",
        "Firebase Authentication",
        "Cloud Firestore",
        "Material Design",
        "REST API",
        "Git",
        "Mobile Development",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          {/* <img src={attendance} alt="gallery1" />
          <img src={attendance} alt="gallery2" />
          <img src={attendance} alt="gallery3" /> */}
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default SmartAttendance;
